
import React from "react";
import { useVideoFetch } from "@/hooks/useVideoFetch";
import InitialHeroState from "./InitialHeroState";

const HeroSection = () => {
  const {
    url,
    setUrl,
    isLoading,
    isOnline,
    handleSubmit,
  } = useVideoFetch();

  return (
    <InitialHeroState
      url={url}
      onUrlChange={setUrl}
      onSubmit={handleSubmit}
      isLoading={isLoading}
      isOnline={isOnline}
    />
  );
};

export default HeroSection;
